import { render, staticRenderFns } from "./MobileBottomNavigationBar.vue?vue&type=template&id=66f7cc2b&scoped=true&"
import script from "./MobileBottomNavigationBar.vue?vue&type=script&lang=ts&"
export * from "./MobileBottomNavigationBar.vue?vue&type=script&lang=ts&"
import style0 from "./MobileBottomNavigationBar.vue?vue&type=style&index=0&id=66f7cc2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f7cc2b",
  null
  
)

export default component.exports